import React, { Component } from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './Home'
import { LoginH } from './Login'
import Voting from './Voting'
import { RegisterH } from './Register'
import { FaceRegisterH } from './FaceRegister'
import { FaceVerifyH } from './FaceVerify'
import Dashboard from './Dashboard'
 
export default class RouterComponents extends Component {
  render() {
    return (
    <>
    <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='/Login' element={<LoginH/>}></Route>
        <Route path='/Voting' element={<Voting/>}></Route>
        <Route path='/Register' element={<RegisterH/>}></Route>
        <Route path='/FaceRegister' element={<FaceRegisterH/>}></Route>
        <Route path='/FaceVerify' element={<FaceVerifyH/>}></Route>
        <Route path='/Dashboard' element={<Dashboard/>}></Route>
    </Routes>
    </>
    )
  }
}
